/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ContactDetails } from "./ContactDetails";
import {
    ContactDetailsFromJSON,
    ContactDetailsFromJSONTyped,
    ContactDetailsToJSON,
} from "./ContactDetails";

/**
 *
 * @export
 * @interface ReportFaultRequest
 */
export interface ReportFaultRequest {
    /**
     *
     * @type {string}
     * @memberof ReportFaultRequest
     */
    deviceGroupTag?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ReportFaultRequest
     */
    deviceIdentities?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof ReportFaultRequest
     */
    userFaultDescription?: string;
    /**
     *
     * @type {Array<ContactDetails>}
     * @memberof ReportFaultRequest
     */
    contactDetails?: Array<ContactDetails>;
}

/**
 * Check if a given object implements the ReportFaultRequest interface.
 */
export function instanceOfReportFaultRequest(
    value: object,
): value is ReportFaultRequest {
    return true;
}

export function ReportFaultRequestFromJSON(json: any): ReportFaultRequest {
    return ReportFaultRequestFromJSONTyped(json, false);
}

export function ReportFaultRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ReportFaultRequest {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        deviceIdentities:
            json["deviceIdentities"] == null
                ? undefined
                : json["deviceIdentities"],
        userFaultDescription:
            json["userFaultDescription"] == null
                ? undefined
                : json["userFaultDescription"],
        contactDetails:
            json["contactDetails"] == null
                ? undefined
                : (json["contactDetails"] as Array<any>).map(
                      ContactDetailsFromJSON,
                  ),
    };
}

export function ReportFaultRequestToJSON(
    value?: ReportFaultRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        deviceIdentities: value["deviceIdentities"],
        userFaultDescription: value["userFaultDescription"],
        contactDetails:
            value["contactDetails"] == null
                ? undefined
                : (value["contactDetails"] as Array<any>).map(
                      ContactDetailsToJSON,
                  ),
    };
}
